import { TObject } from '../common-types';

export const enum EDistrictTags {
  DISTRICT_ROLES = 'districtRoles',
  MAP_PORTAL_APPEARANCE = 'mapPortalAppearance',
  APPEARANCE = 'appearance',
  DISTRICTS_SETTINGS = 'districtsSettings',
  QR_CODES_CONFIG = 'qrCodesConfig'
}

export type TDistrictRolesParams = {
  district: string;
};

export type TMapPortalAppearanceQuery = {
  prefix: string;
  appearance: number;
};

export type TAppearanceParams = {
  district: string;
  page: number;
  pageSize: number;
  id?: number;
};

export type TQRCodesConfigParams = {
  prefix: string;
  resultsPerPage: number;
  page: number;
};

export type TPatchDistrictSettingsParams = {
  data: TObject;
  id: number;
};
